import { cva } from 'class-variance-authority';

export const navListCVA = cva('', {
  variants: {
    overflow: {
      dropdown: '',
      scroll: 'overflow-x-auto overflow-y-hidden no-scrollbar scroll-smooth',
      wrap: 'flex-wrap',
    },
    hasDropdown: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      overflow: 'dropdown',
      hasDropdown: false,
      className: 'flex-wrap',
    },
  ],
});
